import slice from './reducer'
import newOwnersDetailsSaga from './sagas'

export const {
  fetchDetailsRequest: newOwnersDetailRequest,
  fetchDetailsSuccess: newOwnersDetailSuccess,
  fetchDetailsError: newOwnersDetailError,

  updateStatusRequest: newOwnerUpdateStatusRequest,
  updateStatusSuccess: newOwnerUpdateStatusSuccess,
  updateStatusError: newOwnerUpdateStatusError,
} = slice.actions

export default slice.reducer
export { newOwnersDetailsSaga }
